import { WebStorageStateStore } from 'oidc-client-ts';
import type { AuthProviderProps } from 'react-oidc-context';
import { env } from '@/lib/env';

/**
 * OIDC config for the `fluentix-web` Keycloak public client.
 *
 * - `response_type: code` + PKCE is the default for `oidc-client-ts`; we don't
 *   need to opt in explicitly. The library generates and stores the code
 *   verifier in `sessionStorage`.
 * - User session is persisted in `localStorage` so refreshes don't bounce the
 *   translator to the login screen mid-edit.
 * - `automaticSilentRenew` keeps the access token fresh in the background
 *   using a hidden iframe against Keycloak's silent-renew flow.
 */
export const oidcConfig: AuthProviderProps = {
  authority: env.keycloakAuthority,
  client_id: env.keycloakClientId,
  redirect_uri: `${env.appBaseUrl}/auth/callback`,
  post_logout_redirect_uri: `${env.appBaseUrl}/login`,
  silent_redirect_uri: `${env.appBaseUrl}/auth/silent-renew`,
  response_type: 'code',
  scope: 'openid profile email',
  automaticSilentRenew: true,
  loadUserInfo: true,
  userStore: new WebStorageStateStore({ store: window.localStorage }),
  // Strip the `?code=...&state=...` query string so a refresh after callback
  // doesn't try to redeem the same code twice.
  onSigninCallback: () => {
    window.history.replaceState({}, document.title, window.location.pathname);
  },
};
